import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Estado global para la gestión de código de producto reservado.
 */
interface ProductCodeState {
  reservedCode: string | null;   // Código reservado
  wasReleased: boolean;          // Indica si el código fue liberado exitosamente
  error: string | null;          // Error en la reservación/liberación
}

/**
 * Estado inicial del slice de código de producto.
 */
const initialState: ProductCodeState = {
  reservedCode: null,
  wasReleased: false,
  error: null,
};

/**
 * Slice para la gestión de código de producto.
 */
const productCodeSlice = createSlice({
  name: 'productCode',
  initialState,
  reducers: {
    /**
     * Establece el código reservado exitosamente.
     */
    setReservedCode(state, action: PayloadAction<string>) {
      state.reservedCode = action.payload;
      state.wasReleased = false;
      state.error = null;
    },

    /**
     * Limpia el código reservado y resetea estados relacionados.
     */
    clearReservedCode(state) {
      state.reservedCode = null;
      state.wasReleased = false;
      state.error = null;
    },

    /**
     * Marca que el código fue liberado exitosamente.
     */
    setWasReleased(state, action: PayloadAction<boolean>) {
      state.wasReleased = action.payload;
    },

    /**
     * Establece un mensaje de error.
     */
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

// Exportaciones
export const {
  setReservedCode,
  clearReservedCode,
  setWasReleased,
  setError,
} = productCodeSlice.actions;

export default productCodeSlice.reducer;
